import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import moment from 'moment'
import { Cached } from '@material-ui/icons'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import { makeStyles, Tooltip } from '@material-ui/core'
import Input from '@material-ui/core/Input'
import { isEmpty } from 'lodash'
import { useHistory } from 'react-router-dom'

import { extractDayRange } from '../utils/extractDate'
import { occupationsObject } from '../utils/dicts'
import { roles, accessMediations, accessSchoolChat } from '../utils/constants'
import Modal from '../components/modal/Modal'
import RoomDetailsView from '../components/view/RoomDetailsView'
import {
  deleteChat,
  getChatsThunk,
  getChatById,
  createMessageRSPA,
  editMessageRSPA,
  deleteMessageRSPA,
  getMessagesRSPA,
  getInterventionMessagesRSPA,
  getRoomsRSPA,
  createChatRSPA,
  clearPrivateRooms,
  clearGroupRooms,
  clearMediationRooms,
  clearArchivedRooms,
  exportMessagesRSPA,
  editRoomRSPA,
  updateGroupRoomReducer
} from '../store/chats/actions'
import { showAlertMessage } from '../store/alert/actions'
import UserAvatar from '../components/shared/UserAvatar'
import StyledSVG from '../components/shared/StyledSVG'
import Button from '../components/button/Button'

import chatBubbleSVG from '../assets/icons/chat-icon.svg'
import mediationAvatarSVG from '../assets/icons/mediation-message.svg'
import closeSideBarArrow from '../assets/icons/arrowlfts.svg'
import searchIcon from '../assets/icons/search-icon.svg'
import privateRoomsSVG from '../assets/icons/chat-private-bubble.svg'
import groupRoomsSVG from '../assets/icons/chat-group-users.svg'
import moderationRoomsSVG from '../assets/icons/chat-moderation-bubble.svg'
import archivedRoomsSVG from '../assets/icons/archive-icon.svg'
import emptyMessageSVG from '../assets/icons/illustration-meditation-relaxed-person.svg'
import initialBannerSVG from '../assets/icons/messages-initial-ilustrator.svg'
import CalendarSVG from '../assets/icons/calendar.svg'
import groupMessageSVG from '../assets/icons/message-group.svg'

import CreateChatForm from '../components/form/CreateChatForm'
import MessageComponent from '../components/messages/Messages'
import ModerationComponent from '../components/messages/ModerationMessages'
import ArchivedMessages from '../components/messages/ArchivedMessages'
import {
  setRoomMenuDestination,
  setRoomMenuType,
  setArchivedType
} from '../store/room_menu/actions'
import TabNavigation from '../components/shared/TabNavigation'
import { useHasAccess } from '../utils/useHasAccess'
import featureFlags from '../featureFlag/featureFlags'

const useStyles = makeStyles(theme => ({
  root: {
    width: '98%',
    height: '87vh',
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    fontFamily: 'Montserrat, Source Sans Pro',
    display: 'flex',
    flexWrap: 'nowrap'
  },
  menu_grid: {
    height: '100%',
    overflow: 'hidden'
  },
  main_content_grid: {
    height: '100%'
  },
  messages_menu: {
    position: 'relative',
    padding: '25px 15px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  messages_menu_header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 8,
    '& h1': {
      fontSize: 24,
      fontWeight: 700,
      color: '#4D5E80',
      [theme.breakpoints.down('1500')]: {
        fontSize: 20
      },
      [theme.breakpoints.down('1280')]: {
        fontSize: 18
      }
    },
    '& .imgMensages': {
      width: '30px',
      [theme.breakpoints.down('1500')]: {
        width: '25px'
      }
    }
  },
  messages_menu_buttons: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    marginBottom: 32,
    width: '100%',
    '& .MuiButton-root': {
      padding: '6px 16px',
      [theme.breakpoints.down('1678')]: {
        padding: '6px 11px'
      },
      [theme.breakpoints.down('1538')]: {
        padding: '6px 10px'
      }
    }
  },
  button_content_wrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    columnGap: 8
  },
  responsive_button: {
    height: 40,
    width: 350,
    gap: 10,
    borderRadius: 8,
    textTransform: 'none',
    fontSize: '15px',
    fontWeight: 600,
    lineHeight: '15.5px',
    transition:
      'background-color 250ms ease, color 250ms ease, border-color 250ms ease',
    '& path': {
      transition: 'stroke 250ms ease'
    },
    [theme.breakpoints.down('1505')]: {
      fontSize: '14px'
    },
    [theme.breakpoints.down('1429')]: {
      fontSize: '12px'
    },
    [theme.breakpoints.down('1230')]: {
      maxWidth: 80
    },
    [theme.breakpoints.down('660')]: {
      fontSize: '10px'
    }
  },
  unselected_button: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#386093',
    backgroundColor: '#FFFFFF',
    color: '#386093',
    '&:hover': {
      borderColor: '#386093',
      backgroundColor: '#FFFFFF'
    },
    '& path': {
      stroke: '#386093'
    }
  },
  selected_button: {
    color: '#FFFFFF',
    backgroundColor: ' #386093',
    border: 'unset !important',
    '&:hover': {
      backgroundColor: '#386093 !important',
      border: 'unset !important'
    },
    '& path': {
      stroke: '#FFFFFF'
    }
  },
  messages_menu_filter: {
    display: 'none',
    flexWrap: 'wrap',
    gap: 8,
    alignItems: 'center',
    marginBottom: 32
  },
  chat_info_label: {
    backgroundColor: '#ADB8CC66',
    width: 'fit-content',
    borderRadius: 4,
    height: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2px 8px',
    '& span': {
      margin: 0,
      fontSize: 10,
      fontWeight: 400,
      color: '#666666'
    }
  },
  messages_menu_filter_status: {
    cursor: 'pointer',
    backgroundColor: '#E0E3E680',
    borderRadius: 4,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0px 16px',
    '& span': {
      fontSize: 10,
      fontWeight: 500,
      color: '#868E96'
    }
  },
  messages_menu_dropdowns: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    overflowY: 'auto',
    flexGrow: 2
  },
  dropdown_arrow: {
    cursor: 'pointer',
    width: 12,
    height: 12,
    transition: 'all 0.2s ease-in-out',
    '& path': {
      stroke: '#375F92'
    }
  },
  dropdown_expanded: {
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    transition: 'height 0.5s ease-in-out',
    '&::-webkit-scrollbar': {
      width: 0
    },
    '& .MuiInputBase-input': {
      fontSize: '18px',
      [theme.breakpoints.down('1630')]: {
        fontSize: '16px'
      },
      [theme.breakpoints.down('1538')]: {
        fontSize: '14px'
      },
      [theme.breakpoints.down('1400')]: {
        fontSize: '12px'
      },
      [theme.breakpoints.down('1280')]: {
        fontSize: '16px'
      },
      [theme.breakpoints.down('750')]: {
        fontSize: '14px'
      },
      [theme.breakpoints.down('750')]: {
        fontSize: '12px'
      },
      [theme.breakpoints.down('672')]: {
        fontSize: '11px'
      },
      [theme.breakpoints.down('600')]: {
        fontSize: '15px'
      }
    }
  },
  dropdown_item: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  dropdown_label: {
    margin: 0,
    fontSize: 16,
    fontWeight: 500,
    color: '#375F92',
    [theme.breakpoints.down('1429')]: {
      fontSize: 14
    },
    [theme.breakpoints.down('1318')]: {
      fontSize: 12
    },
    [theme.breakpoints.down('1280')]: {
      fontSize: 16
    },
    [theme.breakpoints.down('701')]: {
      fontSize: 14
    },
    [theme.breakpoints.down('657')]: {
      fontSize: 11
    },
    [theme.breakpoints.down('600')]: {
      fontSize: 16
    }
  },
  reload_rooms: {
    cursor: 'pointer',
    width: '0.75em',
    height: '0.75em'
  },
  dropdown_btns: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  empty_messages: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '100%',
    '& h1': {
      fontWeight: 600,
      fontSize: 32,
      width: 400,
      textAlign: 'center',
      color: '#386093'
    }
  },
  main_content: {
    width: '98%',
    height: '100%',
    borderLeft: '1px solid rgba(173, 184, 204, 0.5)',
    borderRight: '1px solid rgba(173, 184, 204, 0.5)',
    [theme.breakpoints.down('1200')]: {
      width: '100%',
      borderRight: 'none'
    }
  },
  initial_banner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '100%',
    '& h1': {
      textAlign: 'center',
      margin: 0,
      fontWeight: 700,
      fontSize: 32,
      color: '#386093',
      width: 800,
      [theme.breakpoints.down('1400')]: {
        width: 400,
        fontSize: 25
      },
      [theme.breakpoints.down('990')]: {
        fontSize: 20
      },
      [theme.breakpoints.down('814')]: {
        fontSize: 17,
        width: 350
      },
      [theme.breakpoints.down('765')]: {
        fontSize: 15,
        width: 200
      }
    },
    '& span': {
      textAlign: 'center',
      margin: 0,
      fontWeight: 400,
      fontSize: 24,
      color: '#386093',
      width: 600,
      [theme.breakpoints.down('1400')]: {
        width: 400,
        fontSize: 20
      },
      [theme.breakpoints.down('990')]: {
        fontSize: 15
      },
      [theme.breakpoints.down('814')]: {
        fontSize: 13
      },
      [theme.breakpoints.down('765')]: {
        width: 200
      }
    },
    '& .imgBanner': {
      display: 'flex',
      width: '500px',
      justifyContent: 'center',
      [theme.breakpoints.down('1400')]: {
        width: '450px'
      },
      [theme.breakpoints.down('990')]: {
        width: '360px'
      },
      [theme.breakpoints.down('878')]: {
        width: '330px'
      },
      [theme.breakpoints.down('814')]: {
        width: '300px'
      },
      [theme.breakpoints.down('765')]: {
        width: '250px'
      },
      [theme.breakpoints.down('672')]: {
        width: '200px'
      },
      [theme.breakpoints.down('600')]: {
        width: '250px'
      }
    }
  },
  room_participants: {
    borderRadius: 8,
    backgroundColor: '#F5F6F7',
    padding: 8
  },
  room_participants_selected: {
    backgroundColor: '#E9FAD9 !important'
  },
  horizontal_bar: {
    width: '100%',
    borderBottom: '1px solid #ADB8CC80',
    margin: '8px 0px'
  },
  room_participants_wrapper: {
    borderRadius: 8
  },
  message_section: {
    cursor: 'pointer',
    display: 'flex',
    gap: 8,
    padding: '8px 8px',
    borderRadius: 8
  },
  message_preview: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    overflowX: 'auto'
  },
  message_preview_info: {
    display: 'flex',
    flexDirection: 'column',
    '& h1': {
      color: '#555555',
      fontWeight: 500,
      fontSize: 14,
      margin: 0
    },
    '& span.description': {
      color: '#9F9F9F',
      fontWeight: 400,
      fontSize: 12,
      margin: 0
    }
  },
  chat_name: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  pending_view: {
    width: 16,
    height: 16,
    borderRadius: '100%',
    border: '1px solid #F69E9E',
    color: '#F69E9E',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  search_component: {
    marginTop: '8px',
    marginBottom: '12px',
    padding: '8px 12px',
    borderRadius: 8,
    border: '1px solid #D2D5D8',
    '& input': {
      padding: 0
    }
  },
  useravatar: {
    display: 'block !important',
    width: 'fit-content'
  },
  infiniteScroll: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    overFlowX: 'hidden'
  },
  message_component: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  rootClass: {
    transition: 'width 0.5s ease-in-out',
    width: '70% !important'
  },
  room_details: {
    overflow: 'hidden',
    height: '100%',
    transition: 'width 0.5s ease-in-out'
  },
  room_detail_closed: {
    width: 0
  },
  room_detail_open: {
    width: '30%'
  },
  export_btn: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    '& h1': {
      cursor: 'pointer',
      margin: 0,
      textDecoration: 'underline',
      fontSize: 14,
      color: '#386093'
    }
  },
  resize: {
    width: 6,
    cursor: 'col-resize',
    background: 'transparent'
  },
  export_modal: {
    '& .modal_title': {
      fontWeight: 700,
      fontSize: 20,
      color: '#386093'
    }
  },
  input_date: {
    marginTop: 32,
    '& h1': {
      fontSize: 18,
      fontWeight: 500,
      margin: 0
    },
    '& div.MuiOutlinedInput-root': {
      borderRadius: '8px',
      height: '48px',
      paddingLeft: 0,
      [theme.breakpoints.down('426')]: {
        height: '35px'
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        border: '1px solid #ADB8CC'
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: '1px solid #ADB8CC'
      },
      '& input': {
        minWidth: 'auto',
        '&:-webkit-autofill,input:-webkit-autofill:focus': {
          transition: 'background-color 600000s 0s, color 600000s 0s'
        }
      },
      '& .MuiInputAdornment-positionEnd': {
        width: 24,
        '& .MuiIconButton-root': {
          padding: '10px 7px'
        }
      }
    },
    '& div.MuiFormControl-marginNormal': {
      margin: 0,
      width: '100%',
      [theme.breakpoints.down('426')]: {
        width: 255
      }
    },
    '& fieldset': {
      border: '1px solid #ADB8CC'
    },
    '&.MuiPickersCalendarHeader-dayLabel': {
      color: theme.palette.secondary.main
    },
    '& input:-internal-autofill-selected': {
      background: 'none'
    }
  },
  btns_modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    marginTop: 36
  },
  root_btn: {
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '19.5px',
    textTransform: 'none !important'
  },
  cancel_btn: {
    border: '1px solid #EF7C8F',
    color: '#EF7C8F',
    '&:hover': {
      border: '1px solid #EF7C8F'
    }
  },
  confirm_btn: {
    backgroundColor: '#386093',
    color: '#FFFF',
    width: 165,
    '&:hover': {
      backgroundColor: '#386093'
    }
  }
}))

const NewMessagesPage = ({
  componentAttribute,
  match,
  getChats,
  currentUser,
  rooms_reducer,
  currentRoom,
  getChatById,
  createMessageRSPA,
  editMessageRSPA,
  deleteMessageRSPA,
  getMessagesRSPA,
  getInterventionMessagesRSPA,
  showAlertMessage,
  getRoomsRSPA,
  userOccupations,
  createChatRSPA,
  private_rooms,
  school_config,
  group_rooms,
  mediation_rooms,
  archived_rooms,
  clearPrivateRooms,
  clearGroupRooms,
  clearMediationRooms,
  clearArchivedRooms,
  deleteChat,
  room_menu,
  setRoomMenuDestination,
  setRoomMenuType,
  setArchivedType,
  exportMessagesRSPA,
  editRoomRSPA,
  updateGroupRoomReducer
}) => {
  const isAdmin =
    userOccupations?.includes(roles.SCHOOL_ADMIN) ||
    userOccupations?.includes(roles.VERSAR_ADMIN)
  const canManageRooms = isAdmin && currentUser?.attributes?.can_manage_rooms
  const classes = useStyles()
  const [roomDetails, setRoomDetails] = React.useState({
    isOpen: false,
    attributes: {}
  })
  const history = useHistory()
  const [schoolChat, setSchoolChat] = React.useState({
    bool: false,
    name: '',
    mediation: null
  })
  const [expandedGroupForm, setExpandedGroupForm] = React.useState({
    selected: false
  })
  const [expandedPrivateForm, setExpandedPrivateForm] = React.useState({
    selected: false
  })
  const [moderationOption, setModerationOption] = React.useState({
    selected: false,
    moderationRoomsCount: 0,
    paramsToGetRooms: {
      'q[messages_moderation_status_eq]': 1
    }
  })
  const [archivedOption, setArchivedOption] = React.useState({
    selected: false
  })

  const [searchRoomInputValue, setSearchRoomInputValue] = React.useState({
    private: '',
    group: '',
    mediation: ''
  })
  const sidebarRef = React.useRef(null)
  const [sidebarWidth, setSidebarWidth] = React.useState(375)
  const startXRef = React.useRef(0)
  const startWidthRef = React.useRef(0)
  const frameIdRef = React.useRef(null)
  const [exportModal, setExportModal] = React.useState({
    open: false,
    startDate: moment(new Date()).format('YYYY-MM-DD'),
    endDate: moment(new Date()).format('YYYY-MM-DD')
  })
  const [dateErrors, setDateErrors] = React.useState(null)
  const expandedPrivateSection = room_menu.current_room_type === 1
  const expandedGroupSection = room_menu.current_room_type === 0
  const expandedModerationSection = room_menu.current_room_type === 2
  const archiveRoomsFeatureFlag = featureFlags.archiveRoomsFeature

  const hasAccess = useHasAccess()

  const truncate = (text, limit) => {
    return text?.length > limit ? `${text.slice(0, limit)}...` : text
  }

  const startResizing = e => {
    e.preventDefault()
    startXRef.current = e.clientX
    startWidthRef.current = sidebarWidth
    document.addEventListener('mousemove', resize)
    document.addEventListener('mouseup', stopResizing)
  }

  const resize = e => {
    const delta = e.clientX - startXRef.current
    const minWidth = 375
    const maxWidth = 450
    const rawWidth = startWidthRef.current + delta
    const newWidth = Math.min(maxWidth, Math.max(minWidth, rawWidth))

    // Throttle do setState para não re-renderar a cada pixel
    if (frameIdRef.current) cancelAnimationFrame(frameIdRef.current)
    frameIdRef.current = requestAnimationFrame(() => {
      if (sidebarRef.current) {
        sidebarRef.current.style.width = `${newWidth}px`
      }
      setSidebarWidth(newWidth)
    })
  }

  const stopResizing = () => {
    if (frameIdRef.current) cancelAnimationFrame(frameIdRef.current)
    document.removeEventListener('mousemove', resize)
    document.removeEventListener('mouseup', stopResizing)
  }

  const clearAllDropdowns = () => {
    clearPrivateRooms()
    clearGroupRooms()
    clearMediationRooms()
    clearArchivedRooms()
  }

  const handleExpandDropdown = roomType => {
    // 0 -> group
    // 1 -> private
    // 2 -> mediation
    // 3 -> archived

    setRoomMenuType(+roomType)

    setModerationOption(prev => ({ ...prev, selected: false }))

    const privateTypeWithoutRooms =
      roomType === 1 && !(private_rooms?.items?.length > 0)
    const groupTypeWithoutRooms =
      roomType === 0 && !(group_rooms.items.length > 0)
    const mediationTypeWithoutRooms =
      roomType === 2 && !(mediation_rooms?.items?.length > 0)
    if (
      privateTypeWithoutRooms ||
      groupTypeWithoutRooms ||
      mediationTypeWithoutRooms
    ) {
      getChats({ page: 1 })
    }
  }

  const handleChangeDestination = destination => {
    setRoomMenuDestination(destination)
    setModerationOption(prev => ({ ...prev, selected: false }))
    setArchivedOption(prev => ({ ...prev, selected: false }))
    clearAllDropdowns()
    getChats({
      page: 1
    })
  }

  const handleSearchRoom = async (event, type) => {
    if (event.key === 'Enter') {
      switch (type) {
        case 0:
          clearGroupRooms()
          getChats({
            page: 1,
            params: { 'q[name_cont]': searchRoomInputValue.group }
          })
          break
        case 1:
          clearPrivateRooms()
          getChats({
            page: 1,
            params: {
              'q[room_participants_user_name_cont]':
                searchRoomInputValue.private
            }
          })
          break
        case 2:
          clearMediationRooms()
          getChats({
            page: 1,
            withoutFractalIdFilter: true,
            params: {
              'q[name_cont]': searchRoomInputValue.mediation
            }
          })
          break
        default:
          break
      }
    }
  }

  const handleClickRoom = id => {
    handleUnselectForms()
    history.push(`/rooms/${id}`)
  }

  const handleUnselectForms = () => {
    setExpandedPrivateForm(prev => {
      return {
        ...prev,
        selected: false
      }
    })
    setExpandedGroupForm(prev => {
      return {
        ...prev,
        selected: false
      }
    })
  }

  const handleTopOptions = optNumber => {
    switch (optNumber) {
      case 0:
        setExpandedPrivateForm(prev => {
          setExpandedGroupForm(prevGroup => {
            return { ...prevGroup, selected: false }
          })
          setModerationOption(prevModeration => {
            return { ...prevModeration, selected: false }
          })
          setArchivedOption(prevArchived => {
            return { ...prevArchived, selected: false }
          })
          return { ...prev, selected: !prev.selected }
        })
        break
      case 1:
        setExpandedGroupForm(prev => {
          setExpandedPrivateForm(prevDirect => {
            return { ...prevDirect, selected: false }
          })
          setModerationOption(prevModeration => {
            return { ...prevModeration, selected: false }
          })
          setArchivedOption(prevArchived => {
            return { ...prevArchived, selected: false }
          })
          return { ...prev, selected: !prev.selected }
        })
        break
      case 2:
        setModerationOption(prev => {
          setExpandedPrivateForm(prevDirect => {
            return { ...prevDirect, selected: false }
          })
          setExpandedGroupForm(prevGroup => {
            return { ...prevGroup, selected: false }
          })
          setArchivedOption(prevArchived => {
            return { ...prevArchived, selected: false }
          })
          return { ...prev, selected: !prev.selected }
        })
        break
      case 3:
        setArchivedOption(prev => {
          setExpandedPrivateForm(prevDirect => {
            return { ...prevDirect, selected: false }
          })
          setExpandedGroupForm(prevGroup => {
            return { ...prevGroup, selected: false }
          })
          setModerationOption(prevModeration => {
            return { ...prevModeration, selected: false }
          })
          return { ...prev, selected: !prev.selected }
        })
        break
      default:
        break
    }
  }

  const handleMainContent = () => {
    if (expandedPrivateForm.selected || expandedGroupForm.selected) {
      return (
        <CreateChatForm
          handleUnselectForms={handleUnselectForms}
          isDirectMsg={expandedPrivateForm.selected}
          isGroupMsg={expandedGroupForm.selected}
        />
      )
    } else if (moderationOption.selected) {
      return (
        <ModerationComponent
          history={history}
          setModerationOption={setModerationOption}
          roomsReducer={rooms_reducer}
          getRooms={getChats}
          moderationOption={moderationOption}
        />
      )
    } else if (archivedOption.selected) {
      return (
        <ArchivedMessages
          history={history}
          archivedRoomType={room_menu.archived_section.room_type}
          setArchivedType={setArchivedType}
          currentUser={currentUser}
          roomsReducer={rooms_reducer}
          getRooms={getChats}
          setArchivedOption={setArchivedOption}
        />
      )
    } else {
      if (!isEmpty(currentRoom) && match?.params?.chatId) {
        return (
          <div className={classes.message_component}>
            <MessageComponent
              getRoomsRSPA={getRoomsRSPA}
              schoolConfig={school_config}
              rootClass={roomDetails.isOpen ? classes.rootClass : ''}
              setRoomDetails={setRoomDetails}
              history={history}
              createChatRSPA={createChatRSPA}
              isAdmin={isAdmin}
              schoolChat={schoolChat}
              showAlertMessage={showAlertMessage}
              createMessageRSPA={createMessageRSPA}
              editMessageRSPA={editMessageRSPA}
              deleteMessageRSPA={deleteMessageRSPA}
              getInterventionMessagesRSPA={getInterventionMessagesRSPA}
              getMessagesRSPA={getMessagesRSPA}
              currentUser={currentUser}
              currentRoom={currentRoom}
            />
            <div
              className={`${classes.room_details} ${
                roomDetails.isOpen
                  ? classes.room_detail_open
                  : classes.room_detail_closed
              }`}
            >
              <RoomDetailsView
                archiveRoomsFeatureFlag={archiveRoomsFeatureFlag}
                editRoomRSPA={editRoomRSPA}
                updateGroupRoomReducer={updateGroupRoomReducer}
                canManageRooms={canManageRooms}
                deleteChat={deleteChat}
                currentUser={currentUser}
                showAlertMessage={showAlertMessage}
                setRoomDetails={setRoomDetails}
                isAdmin={isAdmin}
                currentRoom={currentRoom}
              />
            </div>
          </div>
        )
      } else {
        if (
          group_rooms?.items?.length < 1 &&
          private_rooms?.items?.length < 1 &&
          mediation_rooms?.items?.length < 1
        ) {
          return (
            <div className={classes.empty_messages}>
              <img className='imgBanner' src={emptyMessageSVG} />
              <h1>Ainda não há mensagens por aqui!</h1>
            </div>
          )
        } else {
          return (
            <div className={classes.initial_banner}>
              <img className='imgBanner' src={initialBannerSVG} />
              <h1>Bem-vindo(a) à sua central de mensagens!</h1>
              <span>
                Selecione uma conversa para visualizar<br /> seu histórico ou
                inicie uma nova conversa.
              </span>
            </div>
          )
        }
      }
    }
  }

  const handleCloseModal = () => {
    setExportModal(prev => ({ ...prev, open: false }))
  }

  const handleOpenModal = () => {
    setExportModal(prev => ({ ...prev, open: true }))
  }

  const handleChangeDate = (date, inputName) => {
    if (date === null) {
      setExportModal(prev => ({ ...prev, [inputName]: null }))
    } else if (moment.isMoment(date)) {
      setExportModal(prev => ({
        ...prev,
        [inputName]: moment(date).format('YYYY-MM-DD')
      }))
    }
  }

  const handleConfirmExport = async () => {
    await exportMessagesRSPA({
      start_date: extractDayRange(exportModal.startDate).beginningOfDay,
      end_date: extractDayRange(exportModal.endDate).endOfDay
    })
      .then(res => {
        const url = window.URL.createObjectURL(res.data)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `mensagens_${exportModal.startDate}_${exportModal.endDate}.xlsx`
        )
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
        showAlertMessage(
          'Relatório de mensagens gerado com sucesso.',
          'success'
        )
      })
      .catch(error => {
        console.error(error)
        showAlertMessage('Falha ao exportar relatório de mensagens.', 'error')
      })
      .finally(() => {
        handleCloseModal()
      })
  }

  React.useEffect(async () => {
    clearAllDropdowns()
    getChats({
      page: 1
    })
    // quantitativo de mensagens para moderação
    getRoomsRSPA({
      params: {
        ...moderationOption.paramsToGetRooms
      }
    }).then(res => {
      setModerationOption(prev => ({
        ...prev,
        moderationRoomsCount: res.meta.total_count
      }))
    })
  }, [])

  React.useEffect(
    () => {
      if (match?.params?.chatId) {
        getChatById(match.params.chatId)
      }
    },
    [match?.params?.chatId]
  )

  React.useEffect(
    () => {
      if (currentRoom?.id && match?.params?.chatId) {
        const name = `${currentRoom?.room_participants?.[0]?.user?.name} + ${
          currentRoom?.room_participants?.[1]?.user?.name
        }`
        setSchoolChat({
          bool: !currentRoom?.room_participants
            ?.map(item => +item?.user?.fractal_id)
            .includes(+currentUser.attributes.fractal_id),
          name,
          mediation:
            currentRoom?.mediation_message_id &&
            currentRoom.room_type === 'group'
        })
      }
    },
    [currentRoom]
  )

  return (
    <Grid className={classes.root} container>
      <Grid
        className={classes.menu_grid}
        item
        ref={sidebarRef}
        style={{
          width: sidebarWidth
        }}
      >
        <div className={classes.messages_menu}>
          <div className={classes.messages_menu_header}>
            <img className='imgMensages' src={chatBubbleSVG} />
            <h1>Mensagens</h1>
          </div>
          <div className={classes.messages_menu_buttons}>
            <Button
              onClick={() => handleTopOptions(0)}
              {...(!expandedPrivateForm.selected
                ? { variant: 'outlined' }
                : {})}
              className={`${classes.responsive_button} ${
                expandedPrivateForm.selected
                  ? classes.selected_button
                  : classes.unselected_button
              }`}
            >
              <div className={classes.button_content_wrapper}>
                <StyledSVG src={privateRoomsSVG} width={24} height={24} />
                <p>Nova mensagem</p>
              </div>
            </Button>
            <Button
              onClick={() => handleTopOptions(1)}
              {...(!expandedGroupForm.selected ? { variant: 'outlined' } : {})}
              className={`${classes.responsive_button} ${
                expandedGroupForm.selected
                  ? classes.selected_button
                  : classes.unselected_button
              }`}
            >
              <div className={classes.button_content_wrapper}>
                <StyledSVG src={groupRoomsSVG} width={24} height={24} />
                <p>Novo grupo</p>
              </div>
            </Button>
            {isAdmin && (
              <Button
                onClick={() => handleTopOptions(2)}
                {...(!moderationOption.selected ? { variant: 'outlined' } : {})}
                className={`${classes.responsive_button} ${
                  moderationOption.selected
                    ? classes.selected_button
                    : classes.unselected_button
                }`}
              >
                <div className={classes.button_content_wrapper}>
                  <StyledSVG src={moderationRoomsSVG} width={24} height={24} />
                  <p>
                    Moderação<span>
                      ({moderationOption.moderationRoomsCount})
                    </span>
                  </p>
                </div>
              </Button>
            )}
            {archiveRoomsFeatureFlag && (
              <Button
                onClick={() => handleTopOptions(3)}
                {...(!archivedOption.selected ? { variant: 'outlined' } : {})}
                className={`${classes.responsive_button} ${
                  archivedOption.selected
                    ? classes.selected_button
                    : classes.unselected_button
                }`}
              >
                <div className={classes.button_content_wrapper}>
                  <StyledSVG src={archivedRoomsSVG} width={24} height={24} />
                  <p>Arquivadas</p>
                </div>
              </Button>
            )}
          </div>
          <div className={classes.messages_menu_filter}>
            <div className={classes.messages_menu_filter_status}>
              <span>Não lidas</span>
            </div>
            <div className={classes.messages_menu_filter_status}>
              <span>Em andamento</span>
            </div>
          </div>
          {hasAccess(accessSchoolChat) && (
            <TabNavigation
              defaultOption={room_menu.current_destination}
              options={[
                {
                  id: 1,
                  key: 'Para você',
                  handleChange: () => {
                    handleChangeDestination(1)
                  }
                },
                {
                  id: 0,
                  key: 'Escola',
                  handleChange: () => {
                    handleChangeDestination(0)
                  }
                }
              ]}
            />
          )}
          <div className={classes.messages_menu_dropdowns}>
            {/* 0 */}
            <div className={classes.dropdown_item}>
              <p className={classes.dropdown_label}>Conversas diretas</p>
              <div className={classes.dropdown_btns}>
                {room_menu.current_room_type === 1 &&
                  room_menu.current_destination !== 1 && (
                    <Cached
                      onClick={() => {
                        clearPrivateRooms()
                        getChats({ page: 1 })
                      }}
                      className={classes.reload_rooms}
                    />
                  )}
                <StyledSVG
                  width={12}
                  height={12}
                  className={classes.dropdown_arrow}
                  src={closeSideBarArrow}
                  alt='closeSideBarArrow'
                  onClick={() => {
                    handleExpandDropdown(1)
                  }}
                  style={{
                    transform: !expandedPrivateSection
                      ? 'rotate(90deg)'
                      : 'rotate(270deg)'
                  }}
                />
              </div>
            </div>
            <div
              className={classes.dropdown_expanded}
              style={
                expandedPrivateSection
                  ? { height: '500px', overflow: 'auto' }
                  : { height: '0px' }
              }
            >
              <Input
                disableUnderline
                className={classes.search_component}
                placeholder='Busque pelo nome'
                onChange={event =>
                  setSearchRoomInputValue(prev => ({
                    ...prev,
                    private: event.target.value
                  }))
                }
                onKeyDown={event => {
                  handleSearchRoom(event, 1)
                }}
                value={searchRoomInputValue.private}
                startAdornment={
                  <StyledSVG
                    style={{ marginRight: 4 }}
                    src={searchIcon}
                    width={18}
                    height={18}
                  />
                }
              />
              <InfiniteScroll
                dataLength={private_rooms?.items?.length}
                height={'40vh'}
                next={() => {
                  if (!private_rooms.isFetching) {
                    getChats({
                      page: private_rooms?.pagination?.page + 1,
                      params: {
                        ...(searchRoomInputValue.private.length > 0
                          ? {
                              'q[room_participants_user_name_cont]':
                                searchRoomInputValue.private
                            }
                          : {})
                      }
                    })
                  }
                }}
                loader={<h4>Carregando...</h4>}
                className={classes.infiniteScroll}
                hasMore={
                  private_rooms.isFetching
                    ? true
                    : private_rooms.pagination.total >
                        private_rooms.items.length &&
                      private_rooms.items.length !== 0
                }
                endMessage={
                  <p style={{ textAlign: 'center' }}>
                    <b>Todos os contatos carregados.</b>
                  </p>
                }
              >
                {private_rooms?.items?.length > 0 &&
                  private_rooms?.items.map((item, index) => {
                    const privateRoomWithoutCurrentUser =
                      hasAccess(accessSchoolChat) &&
                      room_menu.current_destination === 0
                    const tooltipMessage = item?.last_message
                      ? `Última mensagem: ${item?.last_message_author} - ${
                          item.last_message.content?.length > 0
                            ? truncate(item.last_message.content, 500)
                            : 'Mensagem sem conteúdo textual'
                        }`
                      : ''
                    const otherRoomParticipant = item?.room_participants.find(
                      item => {
                        return (
                          +item.user.fractal_id !==
                          +currentUser.attributes.fractal_id
                        )
                      }
                    )
                    const roomName = otherRoomParticipant?.user?.name
                    let chatContent
                    if (privateRoomWithoutCurrentUser) {
                      chatContent = (
                        <div>
                          <Tooltip
                            key={`${item.id}${index}`}
                            title={tooltipMessage}
                            leaveDelay={50}
                            placement='right'
                            disableFocusListener
                            disableInteractive
                          >
                            <div
                              onClick={() => handleClickRoom(item.id)}
                              className={`${
                                classes.room_participants_wrapper
                              } ${
                                +match?.params?.chatId === +item.id
                                  ? classes.room_participants_selected
                                  : ''
                              }`}
                            >
                              <div
                                key={`${item.id} ${Math.random()}`}
                                className={classes.message_section}
                              >
                                <UserAvatar
                                  avatarUrl={
                                    item.room_participants[0]?.user?.avatar_url
                                  }
                                  userName={
                                    item.room_participants[0]?.user?.name
                                  }
                                  withoutUserName
                                  className={classes.useravatar}
                                />
                                <div className={classes.message_preview}>
                                  <div className={classes.message_preview_info}>
                                    <div className={classes.chat_name}>
                                      <h1>
                                        {item.room_participants[0]?.user?.name}
                                      </h1>
                                      {item?.pending_messages_count > 0 && (
                                        <div className={classes.pending_view}>
                                          {item?.pending_messages_count}
                                        </div>
                                      )}
                                    </div>
                                    <span className='description'>
                                      {
                                        occupationsObject[
                                          item.room_participants[0]
                                            ?.occupation_name
                                        ]
                                      }
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div
                                key={`${item.id} ${Math.random()}`}
                                className={classes.message_section}
                              >
                                <UserAvatar
                                  avatarUrl={
                                    item.room_participants[1]?.user?.avatar_url
                                  }
                                  userName={
                                    item.room_participants[1]?.user?.name
                                  }
                                  withoutUserName
                                  className={classes.useravatar}
                                />
                                <div className={classes.message_preview}>
                                  <div className={classes.message_preview_info}>
                                    <div className={classes.chat_name}>
                                      <h1>
                                        {item.room_participants[1]?.user?.name}
                                      </h1>
                                    </div>
                                    <span className='description'>
                                      {
                                        occupationsObject[
                                          item.room_participants[1]
                                            ?.occupation_name
                                        ]
                                      }
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Tooltip>
                          <div className={classes.horizontal_bar} />
                        </div>
                      )
                    } else {
                      chatContent = (
                        <div
                          onClick={() => handleClickRoom(item.id)}
                          key={`${item.id} ${Math.random()}`}
                          className={`${classes.message_section} ${
                            +match?.params?.chatId === +item.id
                              ? classes.room_participants_selected
                              : ''
                          }`}
                        >
                          <UserAvatar
                            avatarUrl={otherRoomParticipant?.user?.avatar_url}
                            userName={roomName}
                            withoutUserName
                            className={classes.useravatar}
                          />
                          <div className={classes.message_preview}>
                            <div className={classes.message_preview_info}>
                              <div className={classes.chat_name}>
                                <h1>{roomName}</h1>
                                {item?.pending_messages_count > 0 && (
                                  <div className={classes.pending_view}>
                                    {item?.pending_messages_count}
                                  </div>
                                )}
                              </div>
                              <span className='description'>
                                {
                                  occupationsObject[
                                    otherRoomParticipant?.occupation_name
                                  ]
                                }
                              </span>
                            </div>
                          </div>
                        </div>
                      )
                    }
                    return chatContent
                  })}
              </InfiniteScroll>
            </div>
            {/* 1 */}
            {room_menu.current_destination === 1 &&
              hasAccess(accessMediations) && (
                <>
                  <div className={classes.dropdown_item}>
                    <p className={classes.dropdown_label}>Intervenções</p>
                    <div className={classes.dropdown_btns}>
                      {room_menu.current_room_type === 2 &&
                        room_menu.current_destination !== 1 && (
                          <Cached
                            onClick={() => {
                              clearMediationRooms()
                              getChats({ page: 1 })
                            }}
                            className={classes.reload_rooms}
                          />
                        )}
                      <StyledSVG
                        width={12}
                        height={12}
                        className={classes.dropdown_arrow}
                        src={closeSideBarArrow}
                        alt='closeSideBarArrow'
                        onClick={() => {
                          handleExpandDropdown(2)
                        }}
                        style={{
                          transform: !expandedModerationSection
                            ? 'rotate(90deg)'
                            : 'rotate(270deg)'
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className={classes.dropdown_expanded}
                    style={
                      expandedModerationSection
                        ? { height: '500px', overflow: 'auto' }
                        : { height: '0px' }
                    }
                  >
                    <Input
                      disableUnderline
                      className={classes.search_component}
                      placeholder='Busque pelo nome'
                      onChange={event =>
                        setSearchRoomInputValue(prev => ({
                          ...prev,
                          mediation: event.target.value
                        }))
                      }
                      onKeyDown={event => {
                        handleSearchRoom(event, 2)
                      }}
                      value={searchRoomInputValue.mediation}
                      startAdornment={
                        <StyledSVG
                          style={{ marginRight: 4 }}
                          src={searchIcon}
                          width={18}
                          height={18}
                        />
                      }
                    />
                    <InfiniteScroll
                      dataLength={mediation_rooms.items.length}
                      height={'40vh'}
                      next={() => {
                        if (!mediation_rooms.isFetching) {
                          getChats({
                            page: mediation_rooms?.pagination?.page + 1,
                            params: {
                              ...(searchRoomInputValue.mediation.length > 0
                                ? {
                                    'q[name_cont]':
                                      searchRoomInputValue.mediation
                                  }
                                : {})
                            }
                          })
                        }
                      }}
                      className={classes.infiniteScroll}
                      hasMore={
                        mediation_rooms.isFetching
                          ? true
                          : mediation_rooms.pagination.total >
                              mediation_rooms.items.length &&
                            mediation_rooms.items.length !== 0
                      }
                      loader={<h4>Carregando...</h4>}
                      endMessage={
                        <p style={{ textAlign: 'center' }}>
                          <b>Todas as intervenções carregadas.</b>
                        </p>
                      }
                    >
                      {mediation_rooms.items?.length > 0 &&
                        mediation_rooms.items.map((item, index) => {
                          const tooltipMessage = item?.last_message
                            ? `Última mensagem: ${
                                item?.last_message_author
                              } - ${
                                item.last_message.content?.length > 0
                                  ? truncate(item.last_message.content, 500)
                                  : 'Mensagem sem conteúdo textual'
                              }`
                            : ''
                          const roomName =
                            item.name ||
                            `${item.room_participants
                              ?.filter(
                                rp =>
                                  +rp.user.fractal_id !==
                                  +currentUser.attributes.fractal_id
                              )
                              .map(rp => rp.user.name)
                              .join(' + ')}`
                          return (
                            <Tooltip
                              key={`${item.id}${index}`}
                              title={tooltipMessage}
                              leaveDelay={50}
                              placement='right'
                              disableFocusListener
                              disableInteractive
                            >
                              <div
                                onClick={() => handleClickRoom(item.id)}
                                key={`${item.id} ${Math.random()}`}
                                className={`${classes.message_section} ${
                                  classes.room_participants
                                } ${
                                  +match?.params?.chatId === +item.id
                                    ? classes.room_participants_selected
                                    : ''
                                }`}
                              >
                                <StyledSVG
                                  src={mediationAvatarSVG}
                                  width={40}
                                  height={40}
                                />
                                <div className={classes.message_preview}>
                                  <div className={classes.message_preview_info}>
                                    <div className={classes.chat_name}>
                                      <h1>{roomName}</h1>
                                      {item?.pending_messages_count > 0 && (
                                        <div className={classes.pending_view}>
                                          {item?.pending_messages_count}
                                        </div>
                                      )}
                                    </div>
                                    <span className='description'>
                                      Intervenção
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </Tooltip>
                          )
                        })}
                    </InfiniteScroll>
                  </div>
                </>
              )}
            {/* 2 */}
            <div className={classes.dropdown_item}>
              <p className={classes.dropdown_label}>Grupos</p>
              <div className={classes.dropdown_btns}>
                {room_menu.current_room_type === 0 &&
                  room_menu.current_destination !== 1 && (
                    <Cached
                      onClick={() => {
                        clearGroupRooms()
                        getChats({ page: 1 })
                      }}
                      className={classes.reload_rooms}
                    />
                  )}
                <StyledSVG
                  width={12}
                  height={12}
                  className={classes.dropdown_arrow}
                  src={closeSideBarArrow}
                  alt='closeSideBarArrow'
                  onClick={() => {
                    handleExpandDropdown(0)
                  }}
                  style={{
                    transform: !expandedGroupSection
                      ? 'rotate(90deg)'
                      : 'rotate(270deg)'
                  }}
                />
              </div>
            </div>
            <div
              className={classes.dropdown_expanded}
              style={
                expandedGroupSection
                  ? { height: '500px', overflow: 'auto' }
                  : { height: '0px' }
              }
            >
              <Input
                disableUnderline
                className={classes.search_component}
                placeholder='Busque pelo nome'
                onChange={event =>
                  setSearchRoomInputValue(prev => ({
                    ...prev,
                    group: event.target.value
                  }))
                }
                onKeyDown={event => {
                  handleSearchRoom(event, 0)
                }}
                value={searchRoomInputValue.group}
                startAdornment={
                  <StyledSVG
                    style={{ marginRight: 4 }}
                    src={searchIcon}
                    width={18}
                    height={18}
                  />
                }
              />
              <InfiniteScroll
                dataLength={group_rooms.items.length}
                height={'40vh'}
                next={() => {
                  if (!group_rooms.isFetching) {
                    getChats({
                      page: group_rooms?.pagination?.page + 1,
                      params: {
                        ...(searchRoomInputValue.group.length > 0
                          ? { 'q[name_cont]': searchRoomInputValue.group }
                          : {})
                      }
                    })
                  }
                }}
                className={classes.infiniteScroll}
                hasMore={
                  group_rooms.isFetching
                    ? true
                    : group_rooms.pagination.total > group_rooms.items.length &&
                      group_rooms.items.length !== 0
                }
                loader={<h4>Carregando...</h4>}
                endMessage={
                  <p style={{ textAlign: 'center' }}>
                    <b>Todos os grupos carregados.</b>
                  </p>
                }
              >
                {group_rooms.items.length > 0 &&
                  group_rooms.items.map((item, index) => {
                    const tooltipMessage = item?.last_message
                      ? `Última mensagem: ${item?.last_message_author} - ${
                          item.last_message.content?.length > 0
                            ? truncate(item.last_message.content, 500)
                            : 'Mensagem sem conteúdo textual'
                        }`
                      : ''
                    return (
                      <Tooltip
                        key={`${item.id}${index}`}
                        title={tooltipMessage}
                        leaveDelay={50}
                        placement='right'
                        disableFocusListener
                        disableInteractive
                      >
                        <div
                          onClick={() => handleClickRoom(item.id)}
                          key={`${item.id} ${Math.random()}`}
                          className={` ${classes.message_section} ${
                            classes.room_participants
                          } ${
                            +match?.params?.chatId === +item.id
                              ? classes.room_participants_selected
                              : ''
                          }`}
                        >
                          {item.cover_image_url ? (
                            <img
                              src={item.cover_image_url}
                              style={{
                                width: 40,
                                height: 40,
                                borderRadius: 50
                              }}
                            />
                          ) : (
                            <StyledSVG
                              src={groupMessageSVG}
                              width={40}
                              height={40}
                            />
                          )}
                          <div className={classes.message_preview}>
                            <div className={classes.message_preview_info}>
                              <div className={classes.chat_name}>
                                <h1>{item?.name}</h1>
                                {item?.pending_messages_count > 0 && (
                                  <div className={classes.pending_view}>
                                    {item?.pending_messages_count}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className={classes.chat_info_label}>
                              <span>{`${
                                item?.room_participants?.length
                              } membros`}</span>
                            </div>
                          </div>
                        </div>
                      </Tooltip>
                    )
                  })}
              </InfiniteScroll>
            </div>
          </div>
          {isAdmin && (
            <div className={classes.export_btn}>
              <h1
                onClick={() => {
                  handleOpenModal()
                }}
              >
                Exportação
              </h1>
            </div>
          )}
        </div>
      </Grid>
      <div onMouseDown={startResizing} className={classes.resize} />
      <Grid className={classes.main_content_grid} item style={{ flex: 1 }}>
        <div className={classes.main_content}>{handleMainContent()}</div>
      </Grid>
      <Modal open={exportModal.open} handleClose={() => handleCloseModal()}>
        <div className={classes.export_modal}>
          <h1 className='modal_title'>Informe um intervalo de tempo </h1>
          <MuiPickersUtilsProvider
            libInstance={moment}
            utils={MomentUtils}
            locale={'pt-br'}
          >
            <div className={classes.input_date}>
              <h1>Data inicial</h1>
              <KeyboardDatePicker
                variant='inline'
                disableToolbar
                maxDate={new Date()}
                maxDateMessage='A data deve ser inferior ao dia atual.'
                autoOk
                inputVariant='outlined'
                invalidDateMessage='Data inválida.'
                InputAdornmentProps={{ position: 'start' }}
                format='DD/MM/yyyy'
                margin='normal'
                value={
                  exportModal.startDate ? moment(exportModal.startDate) : null
                }
                onChange={event => handleChangeDate(event, 'startDate')}
                keyboardIcon={
                  <StyledSVG
                    width={16}
                    height={16}
                    color='#ADB8CC'
                    src={CalendarSVG}
                  />
                }
                KeyboardButtonProps={{
                  'aria-label': 'change date'
                }}
                onError={error => {
                  setDateErrors(prev => error)
                }}
              />
            </div>
            <div className={classes.input_date}>
              <h1>Data final</h1>
              <KeyboardDatePicker
                variant='inline'
                minDate={exportModal.startDate}
                minDateMessage='A data final deve ser superior à data inicial'
                maxDate={new Date()}
                maxDateMessage='A data deve ser inferior ao dia atual.'
                disableToolbar
                autoOk
                inputVariant='outlined'
                invalidDateMessage='Data inválida.'
                InputAdornmentProps={{ position: 'start' }}
                format='DD/MM/yyyy'
                margin='normal'
                value={exportModal.endDate ? moment(exportModal.endDate) : null}
                onChange={event => handleChangeDate(event, 'endDate')}
                keyboardIcon={
                  <StyledSVG
                    width={16}
                    height={16}
                    color='#ADB8CC'
                    src={CalendarSVG}
                  />
                }
                KeyboardButtonProps={{
                  'aria-label': 'change date'
                }}
                onError={error => {
                  setDateErrors(prev => error)
                }}
              />
            </div>
          </MuiPickersUtilsProvider>
          <div className={classes.btns_modal}>
            <Button
              className={`${classes.root_btn} ${classes.cancel_btn}`}
              variant='outlined'
              onClick={() => {
                handleCloseModal()
              }}
            >
              Cancelar
            </Button>
            <Button
              className={`${classes.root_btn} ${classes.confirm_btn}`}
              disabled={
                !moment(exportModal.startDate).isValid() ||
                !moment(exportModal.endDate).isValid() ||
                !isEmpty(dateErrors)
              }
              onClick={() => {
                handleConfirmExport()
              }}
            >
              Confirmar
            </Button>
          </div>
        </div>
      </Modal>
    </Grid>
  )
}

const mapStateToProps = (state, props) => {
  return {
    school_config: state.school.school_config,
    private_rooms: state.chats.privateRooms,
    group_rooms: state.chats.groupRooms,
    mediation_rooms: state.chats.mediationRooms,
    archived_rooms: state.chats.archivedRooms,
    currentUser: state.auth.user.data,
    rooms_reducer: state.chats,
    currentRoom: state.chats.currentItem,
    userOccupations: state.auth.currentOccupation,
    room_menu: state.room_menu
  }
}

const mapDispatchToProps = dispatch => ({
  getChats: data => dispatch(getChatsThunk(data)),
  getChatById: data => dispatch(getChatById(data)),
  createMessageRSPA: data => dispatch(createMessageRSPA.request(data)),
  editMessageRSPA: data => dispatch(editMessageRSPA.request(data)),
  deleteMessageRSPA: data => dispatch(deleteMessageRSPA.request(data)),
  createChatRSPA: data => dispatch(createChatRSPA.request(data)),
  clearPrivateRooms: () => dispatch(clearPrivateRooms()),
  deleteChat: data => dispatch(deleteChat(data)),
  clearGroupRooms: () => dispatch(clearGroupRooms()),
  clearMediationRooms: () => dispatch(clearMediationRooms()),
  clearArchivedRooms: () => dispatch(clearArchivedRooms()),
  getRoomsRSPA: data => dispatch(getRoomsRSPA.request(data)),
  getMessagesRSPA: data => dispatch(getMessagesRSPA.request(data)),
  getInterventionMessagesRSPA: data =>
    dispatch(getInterventionMessagesRSPA.request(data)),
  showAlertMessage: (message, type) =>
    dispatch(
      showAlertMessage({
        message,
        severity: type
      })
    ),
  setRoomMenuDestination: data => dispatch(setRoomMenuDestination(data)),
  setRoomMenuType: data => dispatch(setRoomMenuType(data)),
  setArchivedType: data => dispatch(setArchivedType(data)),
  exportMessagesRSPA: data => dispatch(exportMessagesRSPA.request(data)),
  editRoomRSPA: data => dispatch(editRoomRSPA.request(data)),
  updateGroupRoomReducer: data => dispatch(updateGroupRoomReducer(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(NewMessagesPage)
